import { useState, useEffect } from "react";

/**
 * Hook to detect if the viewport is below a certain breakpoint.
 * @param breakpoint - Tailwind breakpoint in pixels (default: 640 for 'sm')
 * @returns boolean indicating if viewport is below the breakpoint
 */
export const useMobile = (breakpoint: number = 640) => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window !== "undefined") {
            return !window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
        }
        return false;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);

        const handleChange = (e: MediaQueryList | MediaQueryListEvent) => {
            setIsMobile(!e.matches);
        };

        handleChange(mediaQuery);
        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [breakpoint]);

    return isMobile;
};
